<template>
<v-container fluid>
    <material-card title="B2S Configuration" inline icon="mdi-mail">
      <!-- <v-card-actions>
        <router-link slot="right" :to="{ name: 'leadManagement' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions> -->

      <form name="updateSettings" @submit.prevent="saveConfiguration">
        <div>
          <v-card-component>

<v-row>
<v-col cols="12" lg="6" sm="6">
        <span class="body-2 font-weight-medium">Select Stage</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required
          v-model="enquiryStage"
          @change="getEnquirySubStages()"
          key="id"
          class="my-0 py-1"
          single-line
          placeholder="Select stage"
          :items="enquiryStageData"
          :item-text="enquiryStageData ? 'stage' : ''"
          item-value="stage"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="6" sm="6">
        <span class="body-2 font-weight-medium">Sub stage</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete
          v-model="enquirySubStage"
          key="id"
          class="my-0 py-1"
          single-line
          placeholder="Select sub stage" required
          :items="enquirySubStageData"
          :item-text="enquirySubStageData ? 'name' : ''"
          item-value="id"
        >
        </v-autocomplete>
      </v-col>
<v-col cols="12" lg="6" sm="6">
        <span class="body-2 font-weight-medium"> Call Attempt Count<span class="error--text ml-1">*</span></span>
        <v-text-field type="number" class="my-0 py-1" onKeyPress="if(this.value.length==10) return false;" min="1"
          v-model="callAttemptCount"></v-text-field>
      </v-col>
</v-row>
</v-card-component>
        <v-card-actions class="d-flex justify-end">
          <v-btn bottom :disabled="hasClicked" right elevation="1" color="primary" type="submit">
            <v-icon left> mdi-content-save </v-icon>
            Save
          </v-btn>
        </v-card-actions>
        </div>

      </form>

    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>

</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'

import constants from '@/utils/constants'

export default {
  name: 'addNewSettings',
  props: ['stageID'],
  components: {
    VCardComponent,
    MaterialCard
  },
  data: function () {
    return {
      enquiry: {},
      cardTitle: '',
      cardIcon: '',
      enquiryStage: '',
      enquirySubStage: '',
      enquiryResponse: '',
      enquiryStageData: [],
      enquirySubStageData: [],
      data: [],
      hasClicked: false,
      loader: true,
      formData: {},
      message: 'true',
      isLoaded: 'false',
      callAttemptCount: 1
    }
  },
  async created () {
    if (this.stageID) {
      await this.getEnquiryStageDetails(this.stageID)
    }
    await this.getEnquiryStages()
  },
  async mounted () {
    await this.getEnquiryStages()
  },
  methods: {

    getEnquiryStages: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/getenquirystages`)
        this.enquiryStageData = data.filter(e => {
          if (e.stage !== 'Close' && e.stage !== 'On Board') {
            return e
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getEnquiryStageDetails: async function (stageID) {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/getenquirystagesbyID`, {
          params: {
            stageID: this.stageID
          }
        })
        this.enquiryStageData = data
        this.enquiryStage = data.statusName
        this.enquirySubStage = data.id
        this.callAttemptCount = data.callAttemptCount
        await this.getEnquirySubStages()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getEnquirySubStages: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/getSubenquirystages`, {
          params: {
            enquiryStage: this.enquiryStage
          }
        })
        this.enquirySubStageData = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry sub stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    saveConfiguration: async function () {
      try {
        this.hasClicked = true
        this.loader = true
        this.loadingComponent = this.$buefy.loading.open()

        let inputData = {
          stageID: this.enquirySubStage,
          callAttemptCount: this.callAttemptCount
        }

        await http.post(`${constants.API_URL}/api/update-callattemptcount`,
          inputData)
        this.loader = false
        this.$router.push({ name: 'B2SConfiguration' })
        this.loadingComponent.close()

        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Record updated successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        console.log('Error While updating call attempt count details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loadingComponent.close()

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
